<h4><i class="pi pi-envelope"></i> Notificaciones</h4>
<br>

<div class="p-fluid p-grid">

  <div class="field col-2">
    <span class="p-float-label">
      <p-calendar
        [(ngModel)]="fechaini"
        (ngModelChange)="cambiarfechaini()"
        dateFormat="dd-mm-yy"
        inputId="fechaIni">
      </p-calendar>
      <label for="fechaIni">Desde</label>
    </span>
  </div>

  <div class="field col-2">
    <span class="p-float-label">
      <p-calendar
        [(ngModel)]="fechafin"
        (ngModelChange)="cambiarfechafin()"
        dateFormat="dd-mm-yy"
        inputId="fechaFin">
      </p-calendar>
      <label for="fechaFin">Hasta</label>
    </span>
  </div>

  <div class="field col-2">
    <span class="p-float-label">
      <p-dropdown
        inputId="dropdownActivo"
        [autoDisplayFirst]="true"
        [options]="valoresActivos"
        [(ngModel)]="activa"
        optionLabel="nombre"></p-dropdown>
      <label for="dropdownActivo">Estado</label>
    </span>
  </div>

  <div class="field col-2">
    <p-button
      (click)="buscar()"
      label="Buscar"
      icon="pi pi-search"
      iconPos="right"></p-button>
  </div>

</div>
<br>

<div class="p-text-center">
  <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>
</div>
<p-table *ngIf="lstNotificaciones?.length"
  [value]="lstNotificaciones"
  [rowHover]="true"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-responsive-demo"
  [paginator]="true"
  [rows]="10"
  [alwaysShowPaginator]="false">
  <ng-template pTemplate="header">
    <tr>
      <th>Id</th>
      <th>Fabricante</th>
      <th>Color</th>
      <th>Idformula</th>
      <th>Chip</th>
      <th>Fecha</th>
      <th>Usuario</th>
      <th>Cliente</th>
      <th>País</th>
      <th>Marcar Revisada</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-noti>
    <tr>
      <td>{{ noti.id }}</td>
      <td>{{ noti.fabricante }}</td>
      <td>{{ noti.codigocolor }}</td>
      <td>{{ noti.idformula }}</td>
      <td>{{ noti.chip }}</td>
      <td>{{ noti.fechacrea | date: "dd/MM/yyyy hh:ss" }}</td>
      <td>
        {{ noti.usercrea ?? '' }}<br>
        {{ noti.nombreusercrea ?? '' }}
      </td>
      <td>{{ noti.cliente }}</td>
      <td>{{ noti.pais}}</td>

      <td style="white-space: nowrap">
        <button *ngIf="noti.activa"
          pButton type="button"
          (click)="marcarRevisada(noti)"
          label=""
          icon="pi pi-check"
          iconPos="right"></button>
      </td>
    </tr>

  </ng-template>
</p-table>